export type RoleAutoLogoutTimeValue = '1h' | '4h' | '8h' | '12h';

export const RoleTimeoutAfterValues = new Map<RoleAutoLogoutTimeValue, number>([
  ['1h', 60],
  ['4h', 240],
  ['8h', 480],
  ['12h', 720]
]);

export const DefaultAutoLogoutTime = RoleTimeoutAfterValues.get('12h');
